import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { AuthService } from "./auth.service";


@Injectable()
export class AuthGuard implements CanActivate {

  session = localStorage.getItem('jiraSession')

  constructor(private authService: AuthService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean>|Promise<boolean>|boolean {

    // navigate to previous location
    
    // let url: string = state.url;
    // this.authService.redirectUrl = url; 
    
    if (!this.authService.isLoggedIn && this.session == undefined ) {
        this.router.navigate(['/Login']);
    }
    return true;
  }
}